module.exports = __webpack_public_path__ + "static/img/5.25ce290.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/zh/5.png
// module id = 3Pti
// module chunks = 0